export { default } from './TabPanel';
export type * from './TabPanel';

export { default as tabPanelClasses } from './tabPanelClasses';
export * from './tabPanelClasses';
